import { moduleProviderFactory } from "core/providers";
import { FacilityOrderNewFlowInventoryPreview } from "application/facility-order-new-flow-inventory/pages";
import { InventoryCalculationCutbackEdit } from "application/facility-order/pages";
import { OngoingMissingInventoryEmailEdit } from "application/ongoing-missing-inventory/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.inventory-preview",
						pattern: "/:id/new-flow/inventory",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowInventoryPreview,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY",
									route: 'master.app.main.facility-order.facility-order-new-flow.inventory-preview'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.inventory-edit",
						pattern: "/:facilityOrderId/new-flow/inventory/:id/isCutback/:isCutback",
						tabTitle:'Edit Inventory Calculation',
						component: InventoryCalculationCutbackEdit,
						authorization: "facilityOrderSection.update",
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY",
									route: 'master.app.main.facility-order.facility-order-new-flow.inventory-preview'
								},
								{
									title: "FACILITY_ORDER.CRUMB.INVENTORY_CALCULATION",
									route: 'master.app.main.facility-order.facility-order-new-flow.inventory-edit'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.inventory-preview",
						}
					},
					{
						name: "master.app.main.facility-order.ongoing-missing-inventory.new-flow-edit-email",
						pattern: "/:facilityOrderId/new-flow/ongoing-missing-inventory",
						component: OngoingMissingInventoryEmailEdit,
						data: {
							crumbs: [
								{
                                    title: "FACILITY_ORDER.CRUMB.INVENTORY",
									route: 'master.app.main.facility-order.facility-order-new-flow.inventory-preview'
                                },
                                {
                                    title: "Inventory Continuously Not Received",
                                    route: 'master.app.main.facility-order.ongoing-missing-inventory.new-flow-edit-email'
                                }
							]
						}
					},	
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
